module.exports = __webpack_public_path__ + "img/service-head-bg-1.b254cd25.jpg";